import { getSvocId, getMemberId, getUserId } from '../utils/user';

const memberId = getMemberId();
const svocId = getSvocId();
const userId = getUserId();

export const OMS_ORDERS_PATH = '/oms/customer/order/v1';

export const OMS_LOCKER_CODE_PATH = `${OMS_ORDERS_PATH}/user/${userId}/locker/code`;
